import script from "./AuditResultCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditResultCard.vue?vue&type=script&setup=true&lang=js"

import "./AuditResultCard.vue?vue&type=style&index=0&id=0794589a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0794589a"]])

export default __exports__